import { useEffect } from 'react'

type UsePageLeaveOptions = {
  callback: () => void
  showDialog?: boolean
}

export const usePageLeave = ({
  callback,
  showDialog = false,
}: UsePageLeaveOptions) => {
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      callback()

      if (showDialog) {
        event.preventDefault()
        event.returnValue = ''
      }
    }

    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [callback, showDialog])
}
